import script from "./QueueTable.vue?vue&type=script&setup=true&lang=ts&generic=T"
export * from "./QueueTable.vue?vue&type=script&setup=true&lang=ts&generic=T"

const __exports__ = script;

export default __exports__